import { render } from "./App.vue?vue&type=template&id=d1ecea4e"
const script = {}

import exportComponent from "/Users/zhouyuan/work/project/hand-mobile-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__